import { useEventModel } from "applesauce-react/hooks";
import { Model } from "applesauce-core";
import { NostrEvent } from "nostr-tools";
import { NUTZAP_KIND } from "applesauce-wallet/helpers";

function EventNutzapsModel(eventId: string): Model<NostrEvent[]> {
  return (events) => events.timeline({ kinds: [NUTZAP_KIND], "#e": [eventId] });
}

export default function useEventNutzaps(event?: NostrEvent) {
  return useEventModel(EventNutzapsModel, event ? [event.id] : undefined) ?? [];
}
